// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-fixed {\n  width: 340px;\n  top: 0;\n  position: fixed;\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n}\n.tag-index .right-fixed,\n.article-page .right-fixed,\n.channel-index .right-fixed,\n.channel-sub .right-fixed {\n  width: 340px;\n  top: 60px;\n  position: fixed;\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n}\n", ""]);
// Exports
module.exports = exports;
